export class DistributionWorkflowError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "DistributionWorkflowError";
  }
}

export class MissingDistributionBatchIdError extends DistributionWorkflowError {
  constructor() {
    super("distributionBatchId is null or undefined");
    this.name = "MissingDistributionBatchIdError";
  }
}
